import { TCarbonProjectData } from "../../../types";
import { StarRating } from "../../../components/StarRating";
import { useState } from "react";
interface ProjectInformationProps {
  projectData?: TCarbonProjectData;
  recommendationProjectData?: any;
  className?: string;
  projectType: string;
}

// TODO: Temp
export type recommendationData = {
  sumOfConservation: number | undefined;
  sumOfReforestationHigh: number | undefined;
  sumOfReforestationLow: number | undefined;
  sumOfReforestationMedium: number | undefined;
  sumOfAboveGroundBiomassTonnes: number | undefined;
  sumOfSoilOrganicCarbonTonnes: number | undefined;
};

export const ProjectInformation = ({ projectData, projectType }: ProjectInformationProps) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedLink, setSelectedLink] = useState<string>("");

  const handleRedirect = (url: URL) => {
    try {
      const newUrl = new URL(url);
      window.open(newUrl, "_blank");
    } catch (error) {
      console.error("Invalid URL:", error);
      setSelectedLink("");
    }
  };

  const handleSetLink = (url: string) => {
    setSelectedLink(url);
    setShowModal(true);
  };

  const convertDateString = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString("en-us", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };

  const projectInformationDatas = [
    {
      label: "ID",
      value: projectData?.properties?.project_id ?? "coming soon",
    },
    projectData?.properties?.proponent_name && {
      label: "Proponent",
      value: projectData?.properties?.proponent_name,
    },
    {
      label: "Project Type",
      value: projectData?.properties?.project_type
        ? projectData?.properties?.project_type
        : "coming soon",
    },
    {
      label: "Credit Period Term",
      value: `${convertDateString(
        projectData?.properties?.credit_period_start_date ?? "",
      )} - ${convertDateString(projectData?.properties?.credit_period_end_date ?? "")}`,
    },
    {
      label: "Methodology",
      value: projectData?.properties?.methodology
        ? projectData?.properties?.methodology
        : "coming soon",
    },
    projectData?.properties?.registry && {
      label: "Registry",
      value: projectData?.properties?.registry,
    },
    {
      label: "URL",
      value: projectData?.properties?.url ? projectData?.properties?.url : "coming soon",
      style: "text-primaryPurple-100 text-wrap",
    },
    {
      label: "Country",
      value: projectData?.properties?.country ? projectData?.properties?.country : "coming soon",
    },
    {
      label: "Estimated Annual Emission Reductions",
      value: projectData?.properties?.estimated_annual_emission_reduction
        ? projectData?.properties?.estimated_annual_emission_reduction
        : "coming soon",
    },
    {
      label: "Acres/ Hectares",
      value: projectData?.properties?.area ?? "Not available",
    },
    {
      label: "Project Validator",
      value: projectData?.properties?.validator_name
        ? projectData?.properties?.validator_name
        : "coming soon",
    },
  ].filter(Boolean) as Array<{ label: string; value: string; style?: string }>;

  // projectInformationDatas for recommendation projects
  // const projectInformationDatasRecommendation = [
  //   {
  //     label: "Country",
  //     value: projectData?.country,
  //   },
  //   {
  //     label: "Acres/ Hectares",
  //     value: recommendationProjectData?.sumOfConservation,
  //   },
  //   {
  //     label: "Project Type",
  //     value: recommendationProjectData?.sumOfConservation,
  //   },
  //   {
  //     label: "Conservation",
  //     value: recommendationProjectData?.sumOfConservation,
  //   },
  //   {
  //     label: "Reforestation High",
  //     value: recommendationProjectData?.sumOfReforestationHigh,
  //   },
  //   {
  //     label: "Reforestation Medium",
  //     value: recommendationProjectData?.sumOfReforestationMedium,
  //   },
  //   {
  //     label: "Reforestation Low",
  //     value: recommendationProjectData?.sumOfReforestationLow,
  //   },
  //   {
  //     label: "Above Ground Biomass in Tonnes",
  //     value: recommendationProjectData?.sumOfAboveGroundBiomassTonnes,
  //   },
  //   {
  //     label: "Soil Organic Carbon in Tonnes",
  //     value: recommendationProjectData?.sumOfSoilOrganicCarbonTonnes,
  //   },
  // ];

  const renderProjectInformations = () => {
    return projectInformationDatas.map((projectInformationData) => (
      <div
        className="flex flex-col gap-2.5"
        key={`${projectInformationData.label}-${projectInformationData.value}`}
      >
        <h4 className="text-sm text-gray-600">{projectInformationData.label}</h4>
        <p
          className={`text-md text-wrap font-medium ${projectInformationData.style ?? ""} ${
            projectInformationData.label === "URL" ? "cursor-pointer" : ""
          }`}
          onClick={
            projectInformationData.label === "URL"
              ? () => handleSetLink(`${projectInformationData.value}`)
              : undefined
          }
          style={{
            wordBreak: projectInformationData.label === "URL" ? "break-all" : "normal",
          }}
        >
          {projectInformationData.value}
        </p>

        {showModal && (
          <div
            onClick={() => setShowModal(!showModal)}
            className={`fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm duration-300 ${
              showModal ? "modal show" : "hidden"
            }`}
          >
            <div className="w-1/3 rounded-lg border border-gray-300 bg-white p-4 py-5">
              <div className="w-full items-center justify-center divide-y divide-gray-400 p-3">
                <h2 className="py-3 text-xl font-semibold">Warning!</h2>

                <p className="py-3">
                  You are about to leave this site and go to a new web page. Are you sure you want
                  to continue?
                </p>

                <div className="flex items-center gap-4 pt-5">
                  <button
                    className="rounded-md border border-red-700 px-4 py-2 text-red-700"
                    onClick={() => setShowModal(!showModal)}
                  >
                    Cancel
                  </button>
                  <button
                    className="rounded-md border border-light-green-900 bg-light-green-900 px-4 py-2 text-white"
                    onClick={() => handleRedirect(new URL(selectedLink))}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    ));
  };
  return (
    <div className="w-full">
      {projectData ? (
        <>
          <div className="rounded-lg bg-white shadow-md">
            <h3 className="p-4 text-lg font-medium ">Project Information</h3>
            <hr className="h-[0.2px] border-t-0 bg-gray-300 opacity-100 dark:opacity-50" />
            <div className="grid grid-cols-3 gap-6 p-4">{renderProjectInformations()}</div>
            <div className="flex flex-col gap-2.5 p-4">
              {projectData?.properties && (
                <div>
                  <h4 className="text-sm">Project Rating</h4>
                  <StarRating rating={4} />
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
